import { FilterableYearOption, ProviderType } from '../DocumentVault.meta';

export const ADD_UPLOADING_FILE = 'DOCUMENT_VAULT/ADD_UPLOADING_FILE';
export const REMOVE_UPLOADING_FILE = 'DOCUMENT_VAULT/REMOVE_UPLOADING_FILE';
export const REMOVE_ALL_UPLOADING_FILES = 'DOCUMENT_VAULT/REMOVE_ALL_UPLOADING_FILES';
export const RESET_STATE = 'DOCUMENT_VAULT/RESET_STATE';
export const SET_IS_WORKFLOW = 'DOCUMENT_VAULT/SET_IS_WORKFLOW';
export const SET_STATE_PARAMS = 'DOCUMENT_VAULT/SET_STATE_PARAMS';
export const SET_FIDELITY_FILTERABLE_YEAR_OPTION =
  'DOCUMENT_VAULT/SET_FIDELITY_FILTERABLE_YEAR_OPTION';
export const SET_FILE_PENDING_CONFIRMATION = 'DOCUMENT_VAULT/SET_CONFIRMATION_TO_UPLOAD';

/**
 * When we are inside the comprehensive workflow, we cannot use the URL to keep
 * the context (clientId, path and isFromExternalSource). In that case, we will
 * use the Redux store, hence this new interface StateParams.
 */
export interface StateParams {
  path: string;
  providerType: ProviderType;
  filterableByYear: boolean;
}

export const addUploadingFile = (payload: { fileId: string; file: File; path: string }) => ({
  type: ADD_UPLOADING_FILE,
  payload,
});

export const removeUploadingFile = (payload: { fileId: string }) => ({
  type: REMOVE_UPLOADING_FILE,
  payload,
});

export const setIsWorkFlow = (payload: { isWorkflow: boolean }) => {
  return {
    type: SET_IS_WORKFLOW,
    payload,
  };
};

export const setStateParams = (payload: { stateParams: StateParams }) => ({
  type: SET_STATE_PARAMS,
  payload,
});

export const resetState = () => ({
  type: RESET_STATE,
});

export const setFidelityFilterableYearOption = (payload: {
  fidelityFilterableYearOption: FilterableYearOption;
}) => ({
  type: SET_FIDELITY_FILTERABLE_YEAR_OPTION,
  payload,
});

export const setFilePendingConfirmation = (
  payload:
    | {
        fileId: string;
        file: File;
        path: string;
      }[]
    | null,
) => ({
  type: SET_FILE_PENDING_CONFIRMATION,
  payload,
});
